import styled from 'styled-components';

export const HotkeyButtonStyles = styled.button`
	display: inline-flex;
	border: 0;
	border-radius: 1rem;
	padding: 0.25rem 0.375rem;
	background: ${({ theme }) => theme.v3.colors.gray[4]};
	text-align: center;

	.text {
		color: ${({ theme }) => theme.v3.colors.dark[4]};
	}
`;
